import { http } from "@/utils/index";

/**
 * 获取南美专线完整数据
 */
export function getSouthAmericaData(language = null) {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/south-america/data", {
    params
  });
}

/**
 * 检查南美专线数据是否已初始化
 */
export function checkSouthAmericaInit(language = null) {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/south-america/check-init", {
    params
  });
}

/**
 * 获取南美专线统计数据
 */
export function getSouthAmericaStats(language = null) {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/south-america/stats", {
    params
  });
}
